import React from 'react'

const t = {
    LANG: {
        FR: 'Français',
        EN: 'English',
        ES: 'Español',
        PT: 'Portugués',
    },
    FR: {
        'Website under maintenance...': 'Site en maintenance...',
        installButton: `Installer l'application`,
        'Open Menu': 'Ouvrir le menu',
        'Close Menu': 'Fermer le menu',
        'Set Language': 'Choisir la langue',
        langBtn: {
            title: 'Cambiar a Español',
            'langFrom': 'FR',
            'langTo': 'EN',
        },
        subnav: {
            career: 'Carrière',
            what: <>C'est quoi ce site?</>,
            todo: 'À faire',
            expenses: 'Dépenses',
        },
    },
    EN: {
        'Website under maintenance...': 'Website under maintenance...',
        installButton: `Install the application`,
        'Open Menu': 'Open menu',
        'Close Menu': 'Close menu',
        'Set Language': 'Set language',
        langBtn: {
            title: 'Basculer vers le Français',
            'langFrom': 'EN',
            'langTo': 'ES',
        },
        subnav: {
            career: 'Career',
            what: <>What is this site?</>,
            todo: 'To do',
            expenses: 'Expenses',
        },
    },
    ES: {
        'Website under maintenance...': 'Sitio web en mantenimiento...',
        installButton: `Instalar la aplicación`,
        'Open Menu': 'Abrir menú',
        'Close Menu': 'Cerrar menú',
        'Set Language': 'Establecer idioma',
        langBtn: {
            title: 'Toggle to English',
            'langFrom': 'ES',
            'langTo': 'PT',
        },
        subnav: {
            career: 'Carrera',
            what: <>¿Qué es este sitio?</>,
            todo: 'Hacer',
            expenses: 'Gastos',
        },
    },
    PT: {
        'Website under maintenance...': 'Site em manutenção...',
        installButton: `Instalar o aplicativo`,
        'Open Menu': 'Abrir menu',
        'Close Menu': 'Fechar Menu',
        'Set Language': 'Definir idioma',
        langBtn: {
            title: 'Alternar para o Francês',
            langFrom: 'PT',
            langTo: 'FR',
        },
        subnav: {
            career: 'Carreira',
            what: <>O que é este site?</>,
            todo: 'Tarefas',
            expenses: 'Despesas',
        },
    },
}

export default t